
import { defineComponent } from 'vue';

import { Step } from '@/components/wizard';
import Slider from '@/components/Slider.vue';
import Explain from '@/components/info/Explain.vue';
import NVAbbr from '@/components/NVAbbr.vue';
import { useCalculationState } from '@/lib/calculationstate';

export default defineComponent({
  name: 'Age',
  components: {
    Slider,
    Step,
    Explain,
    NVAbbr,
  },
  props: {
    step: { type: Number, required: true },
  },
  setup() {
    const state = useCalculationState();
    return {
      state,
    };
  },
});
